<template>
    <div id="app">
        <v-app  v-model="show" class="yellow lighten-4">          
           
            <v-card  class="pa-3 yellow lighten-2" dense>  
                <v-toolbar class="py-0 my-0 yellow lighten-5" >
                    <v-toolbar-title class="my-0 py-0">
                        Comprobante de Devolución de Material para la OT:
                    <span class="red--text font-weight-bold">
                        {{ vOtLink }} - {{ vNombreOt }}
                    </span>
                    </v-toolbar-title>   

                    <v-spacer></v-spacer>
                
                   
                    <div>
                         <v-btn icon @click="imprimirPdf" title="Imprimir comprobante">
                            <v-icon>mdi-printer</v-icon>
                        </v-btn>

                        <v-btn icon @click="irMenuInge()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-toolbar>
            </v-card> 

            <v-card  class="pa-3 yellow lighten-3" dense>
                <v-container fluid>                        
                        <v-row dense>
                            <v-col cols="3" sm="3" md="3">
                                Fecha: {{ this.vFechaLink }}
                            </v-col>
                            <v-col cols="3" sm="3" md="3">
                                Comprobante: {{ this.vCompLink  }}
                            </v-col>
                            <v-col cols="6" sm="6" md="6" >
                                 Responsable: {{ this.vUsuarioLink }}
                            </v-col>
                        </v-row>      
                </v-container>                   
            </v-card>               
                  
                  
            <v-card class="yellow lighten-4">
               <v-container fluid>
                    <v-row dense>
                        <v-col>
                            <v-data-table

                                   
                                    dense
                                    :headers="headers"
                                    :items="desserts"    
                                    class="elevation-1"  
                                    item-key="iitem"
                                    :search="search"
                                
                                    :items-per-page.sync="itemsPerPage"
                                    :items-per-page-options="itemsPerPageOptions"    
                                    
                                >
                            </v-data-table> 

                        </v-col>
                    </v-row>
               </v-container>    
            </v-card>

            <v-card class="pa-3 yellow lighten-3">
                        
                   <v-row dense>
                        <v-col cols="12">

                            <v-textarea 
                                dense
                                v-model="vObserva"
                                label="Observación"
                                auto-grow
                                rows="1"
                                                                                                                                        
                            >
                            </v-textarea>
                        </v-col>
                    </v-row>
                
            </v-card>

         
        </v-app>


        <BuscadorOT
            
                :visible="showCarga"
                :pnumot="this.numOT"
                :pnombreot="this.nombreOT"   
                :pflag="this.flag"            
                @close="showCarga = false"
                @otSel="vOtSel = $event"
                
            >
            
        </BuscadorOT>

           <v-dialog
                v-model="vDialogDevolucion"
                max-width="800px"
                persistent
            >
                
                <v-card>  

                    <v-card-title>
                        <v-row class="text-md-center red--text">
                            <!-- <v-col cols="12">
                              <h5>Resumen de Notas de Pedidos relacionado con la orden de trabajo</h5>  
                            </v-col> -->
                            <v-spacer></v-spacer>
                            <v-col cols="auto" class="text-right">                                     
					            <v-btn class="mx-2" fab dark small @click="vDialogDevolucion=false"   color="black"  >
                                    		<v-icon>mdi-close</v-icon>
                                </v-btn>                                     
                            </v-col>                           
                        </v-row>
                    </v-card-title>  
                    
                    <!-- <v-card-text>
                        
                                
                    </v-card-text> -->

                    <v-card-text>
                        <v-container>
                            
                            <v-data-table

                                   
                                    dense
                                    :headers="headersDevo"
                                    :items="dessertsDevo"
                                    class="elevation-1"  
                                    :items-per-page.sync="itemsPerPage"
                                    :items-per-page-options="itemsPerPageOptions" 
                                   
                                                               
                                                      
                            >

                                 
                               

                            </v-data-table>

                           

                        </v-container>
                    </v-card-text>

                   

                </v-card>
            </v-dialog>



    </div>
</template>

<script>

// import Axios from "../../../axios-auth-sistemas";


import Axios from "../../../axios-auth-sistemas";
import moment from "moment";
import  exportXlsFile from "export-from-json";
import jsPDF from "jspdf"; 
import "jspdf-autotable";

import BuscadorOT from "../EI026/BuscadorOT.vue";



export default {
    name:'FichaDevolcionMaterial',
    data(){
        return{        
           
            headers: 
                    [

                    {text: 'Item',value: 'item',  align: "center",sortable: false},
                    {text: 'Articulo',value: 'articulo' ,sortable: false },
                    {text: 'Detalle',value: 'detalle' ,sortable: false },                    
                    {text: 'Cant. Devuelta',value: 'devuelto',   sortable: true,align: 'left'},                  

                    ],
            headersDevo:[
                    {text: 'Fecha',value: 'fecha',  align: "center",sortable: false},
                    {text: 'Comprob',value: 'comprobante',  align: "center",sortable: false},                    
                    {text: 'Item',value: 'item',  align: "center",sortable: false},
                    {text: 'Articulo',value: 'articulo' ,sortable: false },
                    {text: 'Detalle',value: 'detalle' ,sortable: false },                    
                    {text: 'Cant. Devuelta',value: 'devuelto',   sortable: true,align: 'left'},                    
            ],                 
            desserts:[],
            desserts1:[],
            dessertsDevo:[],
            search: '',
            showCarga: false,
            numOT:'',
            nombreOT:'',
            flag:'',
            vOtSel:'',

            vOtrabajo:'',
            vDetalle:'',
            vNota:'',
            vObserva:'',

            itemsPerPage: -1, // Configura itemsPerPage en -1 para mostrar todos los elementos por defecto
            itemsPerPageOptions: [-1,10, 25, 50,75,100,200],

            vNroComprobante:0,
            vRegistrar:false,

            vDialogDevolucion:false,

            vOtLink:'',
            vOtCompLink:'',
            vFechaLink:'', 
            vCompLink:'',
            vUsuarioLink:'',
            vNombreOt:'',




        }

    },

    computed:{

    },

    
    components: { 

        BuscadorOT,
        
    },


  
    watch: {

        vOtSel: function () {

            this.vOtrabajo= this.vOtSel;
         
            this.mostrarCabeceraOT(this.vOtSel)
        },


    },      

    computed: {    
      
        show: {
            get() {
               
                

              
            },
            set(value) {
                if (!value) {
                  
                }
            },
        },  

       
    },

    mounted() {

        console.log("ESTOY EN EL MOUNTED")
        this.vOtLink = this.$route.query.vOtLink;
        this.vCompLink = this.$route.query.vCompLink;

        this.mostrarDevolucion(this.vOtLink, this.vCompLink);


    },  

    created(){
       
    },
    
   

    methods: { 
      
            irMenuInge(){

                this.$router.push({ name: 'MenuInge' });

            },

            mostrarDevolucion(id, id1){

            

                let self = this; 

                self.desserts=[];

                Axios              
               .get("/Ti/MostrarDevolcionLINK?", {
                params: {
                    id: id,
                    id1: id1
                },
                })
                .then(r => {                 

                    console.log("datos base de datos", r.data)

                    if (r.data.length == 0){
                         this.$swal("","No se cargaron devoluciones para esa ot y comprobante", "info")
                    }


                  
                    r.data.forEach(element => {


                        if (self.vFechaLink == "")
                        {

                            this.vFechaLink= element.fecha
                            ? moment(element.fecha).format('DD/MM/YYYY')
                            : ''

                        };

                         if (self.vCompLink == "")
                        {

                            this.vCompLink= element.comprobante;

                        };


                        if (self.vUsuarioLink == "")
                        {

                            this.vUsuarioLink= element.usuario;

                        };

                         if (self.vNombreOt == "")
                        {

                            this.vNombreOt= element.nombreOt;

                        };

                          if (self.vObserva == "")
                        {

                            this.vObserva= element.observa;

                        };

                        self.desserts.push({

                            item: element.item,
                            articulo :element.codigo,
                            detalle: element.detalle,
                            devuelto: element.devuelto,
                         
                            
                        })
                    });
                     
                  
                  


                }).catch(r => {        
                     
                       this.$swal("","La orden de trabajo ingresada esta vacia", "info")
                });  


    

            },



            imprimirPdf(){

                Axios              
               .get("/Ti/MostrarDevolcionLINK?", {
                params: {
                    id: this.vOtLink,
                    id1: this.vCompLink
                },
                })
                .then(r => {                 

                    console.log("impriir PDF", r.data)

                    if (r.data.length == 0){
                         this.$swal("","No se cargaron devoluciones para esa ot y comprobante", "info")
                    }


                  
                    r.data.forEach(element => {
                        this.desserts1.push({

                            item: element.item,
                            articulo :element.codigo,
                            detalle: element.detalle,
                            devuelto: element.devuelto,
                            fecha:  element.fecha ? moment(element.fecha).format('DD/MM/YYYY'): '',
                            ot: element.ot,
                            nombreot: element.nombreOt,
                            observa: element.observa,
                            comprobante: element.comprobante,
                            usuario:element.usuario
                        })
                    });
                     
                     console.log("datos para el pdf",this.desserts1);

                    this.generarPDF();


                }).catch(r => {        
                     
                       this.$swal("","La orden de trabajo ingresada esta vacia", "info")
                });  

            },

            generarPDF(){
                let self = this; 

                console.log("estoy en generar pdf",self.desserts1);

                console.log("detalle a imprimir",self.desserts1);
            

            
                var vm = this;      
                var columns = [
                {title: "IT", dataKey: "item"},
                {title: "Código", dataKey: "codigo"},            
                {title: "Descripcion", dataKey: "detalle"},
                {title: "Cant. Devuelta.", dataKey: "devuelto"},  
                             

                ];
                var doc = new jsPDF();
                doc.setLineWidth(0.5);
                doc.line(10, 11, 200, 11);           
                doc.line(10, 11, 10, 41);
              //  doc.line(165, 28, 200, 28);
            // doc.line(165, 33, 200, 33);
                doc.addImage(
                    "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",
                    "JPEG",
                    15,
                    15,
                    22,
                    22
                );
                doc.setFontSize(13);
                doc.text("DEVOLUCIÓN DE MATERIAL N° " + vm.desserts1[0].comprobante , 65, 24);

                doc.setFontSize(10);
                doc.text("Fecha: " +vm.desserts1[0].fecha, 166, 18);

                doc.setFontSize(11);
                doc.text("ORDEN DE TRABAJO: " +vm.desserts1[0].ot  + " - " + vm.desserts1[0].nombreot , 42, 35);

                doc.setFontSize(12);
                // doc.text("N° COMPROBANTE: " + vm.desserts1[0].comprobante  , 79, 38);
                
                doc.setFontSize(14);
                //doc.text("OT N°: " + this.$store.state.otrabajo , 166, 20);
                doc.line(40, 11, 40, 41);
                          
                doc.setFontSize(11);
                // doc.text("EI079 Rev. 2" , 170, 38);
                doc.line(40, 11, 40, 41);
               // doc.line(165, 11, 165, 41);
                doc.line(10, 41, 200, 41);
                doc.line(200, 11, 200, 41);
                doc.setFontSize(10);
            
            
                doc.autoTable(columns, this.desserts1, {
                theme: 'grid',     
                startY: 45,
                margin: { top: 25, left: 10 , right: 10},
                styles: { fontSize: 7 }
                
                });

            

                var finalO =  doc.autoTable.previous.finalY + 30;

                if (finalO >= 285) {
                    doc.addPage();
                    finalO = 0;
                }

                doc.setFontSize(11);
            //  doc.text("Responsable Tecnico:  "+ vm.desserts3[0].tecnico, 10,finalO+ 45);
                doc.text("Responsable:  "+ vm.desserts1[0].usuario, 10,finalO + 51);

                if (vm.desserts1[0].observa != ""){

                    doc.text("Observación:  "+ vm.desserts1[0].observa, 10,finalO  + 60);

                }

                const pageCount = doc.internal.getNumberOfPages();

                for (var i = 1; i <= pageCount; i++) {
                    doc.setPage(i);
                    doc.text(
                    "Página " + String(i) + " de " + String(pageCount),
                    210 - 20,
                    297 - 10,
                    null,
                    null,
                    "right"
                    );
                }

                doc.save('devolucion_material.pdf');



            },
       



    }


      

     



    
}
</script>

